import { ChildbirthType } from "./childbirth";
import { EventType } from "./event-type";
import { HerdoutType } from "./herdout";
import { MatingType } from "./mating/mating-type";

export class EventTypeMapper {

    private static readonly EVENT_TYPE_MAP = new Map<string, EventType>([
        [MatingType.ARTIFICIAL.name, EventType.MATING],
        [MatingType.NATURAL.name, EventType.MATING],
        [MatingType.IMPLANTATION.name, EventType.MATING],
        [ChildbirthType.INDUCTION.name, EventType.CHILDBIRTH],
        [ChildbirthType.CONVENTIONAL.name, EventType.CHILDBIRTH],
        [ChildbirthType.ABORTION.name, EventType.ABORTION],
        [HerdoutType.DEATH.name, EventType.HERDOUT],
        [HerdoutType.DISCARD.name, EventType.HERDOUT],
        [HerdoutType.SALE.name, EventType.HERDOUT],
        [EventType.DRY.name, EventType.DRY],
        [EventType.PREGNANCY.name, EventType.PREGNANCY],
    ]);

    static getEventBy(type: string): EventType {
        const event = this.EVENT_TYPE_MAP.get(type);
        if (event == null) throw new Error(`[ Type: '${type}' ] not mapped.`);
        return event;
    }

}